import {fetch} from '~/lib/fetch';
import config from '~/configuration';

const retrieve = async (rob_request_id, message_id, index) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query Query($rob_request_id: ID!, $message_id: ID!, $index: Int!) {
            attachment: attachment(
              rob_request_id: $rob_request_id,
              message_id: $message_id,
              index: $index
            )
        } 
        `,
      variables: {
        rob_request_id,
        message_id,
        index,
      },
    }),
  });

  const {attachment} = await response.json();

  return attachment;
};

export default {
  retrieve,
};
